import styled from '@emotion/styled';

const SchoolStatCardValue = styled('em')({
  fontStyle: 'normal',
  fontSize: 32,
  fontWeight: 500,
});

export default SchoolStatCardValue;
